import Image from 'next/legacy/image'
import {
  faLockAlt,
  faPencil,
  faPhotoVideo
} from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Button from 'components/Button'
import { useEditEventAssetModal } from 'components/modals/EditEventAssetModal'
import { EventAsset as IEventAsset, EventAssetType } from 'graphql/generated'
import { useState } from 'react'
import Typography from 'components/common/Typography'

interface IProps {
  asset: Omit<IEventAsset, 'event'>
  isPrivileged: boolean
}

function typeToLabel(type: EventAssetType) {
  switch (type) {
    case EventAssetType.AUDIO_FILE:
      return 'Audio File'
    case EventAssetType.VIDEO_FILE:
      return 'Video File'
    case EventAssetType.IMAGE_FILE:
      return 'Image File'
    default:
      return '(unknown)'
  }
}

function EventAsset({ asset, isPrivileged }: IProps) {
  const [thumbnailFailed, setThumbnailFailed] = useState(false)
  const editAsset = useEditEventAssetModal()
  const onClick = e => {
    e.preventDefault()
    editAsset({ asset })
  }

  // failsafe sanity check... the api shouldn't even return
  // these items in the response
  if (!asset.public && !isPrivileged) {
    return null
  }

  return (
    <div>
      <a
        href={asset.url}
        className="block group relative rounded-lg overflow-hidden border border-gray-200 hover:border-gray-300 h-24 aspect-w-16 aspect-h-9 mb-1"
      >
        {asset.thumbnail && !thumbnailFailed ? (
          <Image
            className={`object-fill`}
            src={asset.thumbnail}
            alt={asset.caption}
            layout="fill"
            onError={() => setThumbnailFailed(true)}
          />
        ) : (
          <div className="w-full h-full flex justify-center items-center bg-gray-100">
            <FontAwesomeIcon
              icon={faPhotoVideo}
              size="2x"
              className="text-gray-400"
            />
          </div>
        )}

        {!asset.public && (
          <Typography
            className="absolute w-full flex justify-center items-center bg-white/75 h-8 border-b border-gray-200"
            color="red"
            uppercase
            size="xs"
          >
            <FontAwesomeIcon icon={faLockAlt} />
            &nbsp;
            {`Unreleased`}
          </Typography>
        )}

        {isPrivileged && (
          <div className="absolute right-0 justify-end p-1 hidden group-hover:flex h-8">
            <Button
              label={'Edit'}
              icon={faPencil}
              size={'xs'}
              color={'gray'}
              onClick={onClick}
            />
          </div>
        )}
      </a>

      <Typography size="sm" color="darkGray">
        {asset.caption}
      </Typography>
      <Typography size="sm" color="darkGray" fontWeight="light">
        {typeToLabel(asset.type)}
      </Typography>
    </div>
  )
}

export default EventAsset
